import { render, staticRenderFns } from "./AirtimeUtilityQuickPayment.vue?vue&type=template&id=a5b7e4d4&scoped=true"
import script from "./AirtimeUtilityQuickPayment.vue?vue&type=script&lang=js"
export * from "./AirtimeUtilityQuickPayment.vue?vue&type=script&lang=js"
import style0 from "./AirtimeUtilityQuickPayment.vue?vue&type=style&index=0&id=a5b7e4d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b7e4d4",
  null
  
)

export default component.exports